import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { getFunctions } from 'firebase/functions';

import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: "AIzaSyCQC7JPlI62fG2yWAO6cd1GdKf-klR6RM4",
  authDomain: "playbracketz.com",
  projectId: "bracketz-d95e2",
  storageBucket: "bracketz-d95e2.firebasestorage.app",
  messagingSenderId: "898822929266",
  appId: "1:898822929266:web:fdaf43b06477ca56b6bbeb",
  measurementId: "G-ZRQCP383GP"
};

const app = initializeApp(firebaseConfig);

// ── APP CHECK (anti-bot protection) ──────────────────────────────────────────
if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-restricted-globals
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider('6LeYG4ssAAAAAEGhJ4cryyu88EV5T0JpEzuRiJHB'),
  isTokenAutoRefreshEnabled: true
});

// ── FCM MESSAGING



// ── FCM MESSAGING ─────────────────────────────────────────────────────────────
let messaging = null;
try {
  messaging = getMessaging(app);
} catch(e) {
  console.warn('FCM not supported in this environment');
}

export const VAPID_KEY = 'BOP7pVv0i2WLoy3hgq_nKkoMF1cYlZruNjsETJnYNjL0qUq3qctC_ovY6mTA4wKqghfbdhdMqDAiPpjZJM78lXs';

export async function requestNotificationPermission(userId) {
  if (!messaging) return null;
  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return null;
    const token = await getToken(messaging, { vapidKey: VAPID_KEY });
    if (token && userId) {
      const { doc, setDoc } = await import('firebase/firestore');
      await setDoc(doc(getFirestore(app), 'userProfiles', userId), {
        fcmToken: token,
        notificationsEnabled: true,
        fcmUpdatedAt: new Date().toISOString(),
      }, { merge: true });
    }
    return token;
  } catch(e) {
    console.warn('Notification permission error:', e);
    return null;
  }
}

export { messaging, getToken, onMessage };
export const db        = getFirestore(app);
export const auth      = getAuth(app);
export const storage   = getStorage(app);
export const analytics = getAnalytics(app);
export const functions = getFunctions(app);
export { logEvent };
export default app;
